// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__XA4Te","cardHead":"Card_cardHead__S25qy"};